module.exports = __webpack_public_path__ + "img/avatar_light.9b4772ea.png";